import type { RJSFSchema, UiSchema } from "@rjsf/utils";

/** The start form's tool-call allowance, as its own schema field declares it. */
export interface ToolCallLimitField {
  minimum: number;
  maximum: number;
  default: number;
  description: string;
}

/** The workflow's `toolCallLimit` field, or null when its start form has none. */
export function toolCallLimitField(schema: RJSFSchema | undefined): ToolCallLimitField | null {
  const field = schema?.properties?.toolCallLimit;
  if (!field || typeof field !== "object") return null;
  const { minimum, maximum, default: fallback, description } = field;
  if (typeof minimum !== "number" || typeof maximum !== "number" || typeof fallback !== "number") return null;
  return { minimum, maximum, default: fallback, description: description ?? "" };
}

/** The workflow's reference run time beside the allowance, e.g. "30–60 min"; null when its form names none. */
export function toolCallLimitEstimate(uiSchema: UiSchema | undefined): string | null {
  const estimate = uiSchema?.toolCallLimit?.["ui:options"]?.estimate;
  return typeof estimate === "string" && estimate ? estimate : null;
}

export function isValidToolCallLimit(value: unknown, field: ToolCallLimitField): value is number {
  return typeof value === "number" && Number.isInteger(value) && value >= field.minimum && value <= field.maximum;
}
